import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import http from "../../utils/axios";

export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers", 
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.per_page) queryParams.append('per_page', params.per_page);
      
      const res = await http.get(`/dashboard/customers?${queryParams.toString()}`);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch customers"
      );
    }
  }
);

export const fetchCustomerById = createAsyncThunk(
  "customers/fetchCustomerById",
  async (uuid, { rejectWithValue }) => {
    try {
      const res = await http.get(`/dashboard/customers/${uuid}`);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch customer details"
      );
    }
  }
);

const customersSlice = createSlice({
  name: "customers",
  initialState: {
    customers: [],
    pagination: null,
    customer: null,
    customerFetchStatus: "idle",
    loading: false,
    error: null,
  },
  reducers: {
    clearCustomer: (state) => {
      state.customer = null;
      state.customerFetchStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.customers = action.payload?.data || [];
        state.pagination = action.payload?.pagination || null;
      })
      .addCase(fetchCustomerById.pending, (state) => {
        state.customerFetchStatus = "loading";
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.customerFetchStatus = "success";
        state.customer = action.payload.data;
      })
      .addCase(fetchCustomerById.rejected, (state) => {
        state.customerFetchStatus = "failed";
        state.customer = null;
      })
      .addMatcher(isPending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addMatcher(isFulfilled, (state) => {
        state.loading = false;
      })
      .addMatcher(isRejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearCustomer } = customersSlice.actions;
export default customersSlice.reducer;